module.exports = __webpack_public_path__ + "static/assets/2c83edd505fcfb9565de1621881df8f5.svg";